<template>
  <div class="layout__width-50 text__align-center layout__display-flex flex-col mx-auto mb-20">
    <div class="mb-10">
      Search
    </div>

    <div class="layout__display-flex align-center">
      <el-input
        placeholder="Search vouchers"
        v-model="filters.search"
        clearable
        @change="onSearch"
        :disabled="isLoading"
      />

      <el-button
        class="button-red button__base ml-10"
        :disabled="isLoading"
        @click="onSearch"
      >
        Search
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VouchersFilters',

  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      filters: {
        search: '',
      },
    };
  },

  methods: {
    onSearch() {
      this.$emit('filters-updated', this.filters)
    },
  },
};
</script>
